"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = exports.Input = exports.FormInputType = void 0;
const react_1 = __importDefault(require("react"));
const Form_1 = __importDefault(require("antd/lib/form/Form"));
const popconfirm_1 = __importDefault(require("antd/lib/popconfirm"));
const row_1 = __importDefault(require("antd/lib/row"));
const Column_1 = require("../Column");
const Input_1 = require("./components/Input");
Object.defineProperty(exports, "Input", {
  enumerable: true,
  get: function () {
    return Input_1.Input;
  }
});
Object.defineProperty(exports, "FormInputType", {
  enumerable: true,
  get: function () {
    return Input_1.FormInputType;
  }
});
class InternalForm extends react_1.default.PureComponent {
  render() {
    const _a = this.props,
      form = _a.form,
      _a$submitButton = _a.submitButton,
      submitButton = _a$submitButton === void 0 ? () => null : _a$submitButton,
      _a$inputs = _a.inputs,
      inputs = _a$inputs === void 0 ? [] : _a$inputs,
      inputContainerStyle = _a.inputContainerStyle,
      formProps = __rest(_a, ["form", "submitButton", "inputs", "inputContainerStyle"]);
    return react_1.default.createElement(Form_1.default, Object.assign({}, formProps), react_1.default.createElement("div", {
      style: inputContainerStyle
    }, inputs.map((_a, index) => {
      var title = _a.title,
        key = _a.key,
        _a$decoratorOptions = _a.decoratorOptions,
        decoratorOptions = _a$decoratorOptions === void 0 ? {} : _a$decoratorOptions,
        _a$inputTrailer = _a.inputTrailer,
        Trailer = _a$inputTrailer === void 0 ? () => null : _a$inputTrailer,
        _a$colValue = _a.colValue,
        colValue = _a$colValue === void 0 ? 8 : _a$colValue,
        _a$gutterValue = _a.gutterValue,
        gutterValue = _a$gutterValue === void 0 ? 8 : _a$gutterValue,
        confirmation = _a.confirmation,
        itemProps = _a.itemProps,
        rowProps = _a.rowProps,
        columnProps = _a.columnProps,
        inputProps = __rest(_a, ["title", "key", "decoratorOptions", "inputTrailer", "colValue", "gutterValue", "confirmation", "itemProps", "rowProps", "columnProps"]);
      const decoratedInput = form.getFieldDecorator(key, decoratorOptions)(react_1.default.createElement(Input_1.Input, Object.assign({}, inputProps)));
      const input = confirmation ? react_1.default.createElement(popconfirm_1.default, Object.assign({}, confirmation), decoratedInput) : decoratedInput;
      return react_1.default.createElement(Form_1.default.Item, Object.assign({
        key: index,
        label: title
      }, itemProps), react_1.default.createElement(row_1.default, Object.assign({
        gutter: gutterValue
      }, rowProps), react_1.default.createElement(Column_1.Column, Object.assign({
        span: colValue
      }, columnProps), input), react_1.default.createElement(Trailer, null)));
    })), submitButton(this.props, form));
  }
}
const Form = _a => {
  var _a$onFieldsChange = _a.onFieldsChange,
    onFieldsChange = _a$onFieldsChange === void 0 ? () => {} : _a$onFieldsChange,
    _a$onValuesChange = _a.onValuesChange,
    onValuesChange = _a$onValuesChange === void 0 ? () => {} : _a$onValuesChange,
    _a$mapPropsToFields = _a.mapPropsToFields,
    mapPropsToFields = _a$mapPropsToFields === void 0 ? () => ({}) : _a$mapPropsToFields,
    props = __rest(_a, ["onFieldsChange", "onValuesChange", "mapPropsToFields"]);
  const WrappedForm = Form_1.default.create({
    onFieldsChange: (_, changedFields, allFields) => onFieldsChange(changedFields, allFields),
    onValuesChange: (_, changedValues, allValues) => onValuesChange(changedValues, allValues),
    mapPropsToFields: formProps => mapPropsToFields(formProps, Form_1.default.createFormField)
  })(InternalForm);
  return react_1.default.createElement(WrappedForm, Object.assign({}, props));
};
exports.Form = Form;
exports.default = exports.Form;